/** @jsx jsx */
import { Fragment } from 'react';
import { jsx } from '@emotion/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import * as S from './styles';

interface ISortToggle {
  isAsc: boolean;
  ascLabel: string;
  descLabel: string;
  toggleIsAsc: () => void;
  isDisabled?: boolean;
}

export default function SortToggle({
  isAsc,
  ascLabel,
  descLabel,
  toggleIsAsc,
  isDisabled,
}: ISortToggle) {
  return (
    <S.SortContainer role="button" onClick={toggleIsAsc} isDisabled={isDisabled}>
      {isAsc ? (
        <Fragment>
          {ascLabel}
          <ExpandMore />
        </Fragment>
      ) : (
        <Fragment>
          {descLabel}
          <ExpandLess />
        </Fragment>
      )}
    </S.SortContainer>
  );
}
